// For HTTP error code, keep the enum member name in the form ERROR_{statusCode}.
export enum ErrorCode {
  USER_NOT_FOUND = 0,
  CONTEST_CODE_NOT_FOUND = 1,
  ERROR_401 = 2,
  ERROR_500 = 3,
  UNKNOWN_ERROR = 4,
  INVALID_GOAL = 5,
  LEADERBOARD_NOT_FOUND = 6,
}

export const ERROR_MESSAGES: Record<ErrorCode, string> = {
  [ErrorCode.CONTEST_CODE_NOT_FOUND]: "Le code du contest est invalide. Veuillez vérifier l'URL.",
  [ErrorCode.ERROR_401]: "Erreur, vous n'êtes pas autorisé à accéder à cette page.",
  [ErrorCode.ERROR_500]: 'Erreur du serveur. Veuillez réesayer plus tard.',
  [ErrorCode.INVALID_GOAL]: "Le goal fournis dans l'url est invalide.",
  [ErrorCode.LEADERBOARD_NOT_FOUND]: 'Ce leaderboard est introuvable. Vérifiez le lien utilisé.',
  [ErrorCode.UNKNOWN_ERROR]: 'Erreur inconnu.',
  [ErrorCode.USER_NOT_FOUND]: "L'utilisateur n'a pas été trouvé.",
};

export function httpStatusToErrorCode(statusCode: number): ErrorCode | null {
  const errorCodeName: string = `ERROR_${statusCode}`;

  if (Object.values(ErrorCode).includes(errorCodeName))
    return ErrorCode[errorCodeName as keyof typeof ErrorCode];

  return null;
}
